import { createAsyncThunk } from '@reduxjs/toolkit';

import { API } from '@/shared/api';
import { TServerSegment, TUpdatingSegmentData } from '@/shared/types/Editor';
import { Project } from '@/shared/types/Project';

import { RootState } from '../../index';
import { applySavedSegments, revertFailedSegments } from './segmentSaveHelpers';

type UpdateSegments = {
  changedData: TUpdatingSegmentData[];
  project?: Project;
};

const BATCH_SIZE = 50;

/**
 * Разбивает массив на батчи указанного размера
 * @param array - исходный массив
 * @param batchSize - размер батча
 * @returns массив батчей
 */
const chunkArray = <T>(array: T[], batchSize: number): T[][] => {
  const chunks: T[][] = [];
  for (let i = 0; i < array.length; i += batchSize) {
    chunks.push(array.slice(i, i + batchSize));
  }
  return chunks;
};

export const updateSegments = createAsyncThunk<void, UpdateSegments, { state: RootState }>(
  'editor/updateSegments',
  async ({ changedData, project }: UpdateSegments, { dispatch, getState }) => {
    try {
      if (!project) {
        return;
      }

      // Разбиваем данные на батчи для предотвращения ошибки 413 "Payload Too Large"
      const batches = chunkArray(changedData, BATCH_SIZE);

      // Обрабатываем все батчи параллельно и объединяем результаты
      const batchResults = await Promise.all(
        batches.map((batch) => API.updateSegments(project.id, batch).then(({ segments }) => segments)),
      );
      const allUpdatedSegments: TServerSegment[] = batchResults.flat();

      if (!allUpdatedSegments.length) {
        throw new Error();
      }

      applySavedSegments(project.id, allUpdatedSegments, dispatch);
    } catch {
      revertFailedSegments(changedData, { dispatch, getState });
    }
  },
);
